<template>
  <div>
    <br />
    <b-container class="black explorer">
      <h3 class="interactive-title">Leistungskatalog entdecken</h3>
      <div v-if="ozgServiceSearch">
        <vue-bootstrap-typeahead
          class="typeahead col-md-6 offset-md-3"
          placeholder="z.B. Führerschein, Geburt, …"
          @hit="chosen = $event"
          :data="ozgServiceSearch"
          :serializer="item => item.value"
        />
        <br />
        <br />
        <div v-if="ozgService">
          <b-row>
            <b-col class="col-md-6 col-sm-12">
              <h3>
                {{ ozgService.name }}
                <OZGLevelEmoji :level="ozgService.implementationLevel" />
              </h3>
              <p>{{ ozgService.description }}</p>
              <p v-if="ozgService.lastMilestone !== null">
                <b>Letzter Meilenstein: </b>
                {{ ozgService.lastMilestone.status.event }} ({{
                  moment(ozgService.lastMilestone.start).format("DD.MM.YYYY")
                }})
              </p>
              <p v-if="ozgService.nextMilestone !== null">
                <b>Nächster Meilenstein: </b>
                {{ ozgService.nextMilestone.status.event }} ({{
                  moment(ozgService.nextMilestone.start).format("DD.MM.YYYY")
                }})
              </p>
            </b-col>
            <b-col class="col-md-6 col-sm-12">
              <h3>Leistungen</h3>
              <ul class="list-group list-group-flush scrolling-list">
                <li
                  class="list-group-item"
                  v-for="feature in ozgService.feature.edges"
                  v-bind:key="feature.node.id"
                >
                  {{ feature.node.name }}

                  <OZGLevelEmoji
                    :level="feature.node.implementationLevel"
                    :applicableLaws="feature.node.applicableLaws.edges"
                    :partOfMvp="feature.node.partOfMvp"
                    :costsOfRecord="feature.node.costsOfRecord"
                    :partOfReferenceImplementation="
                      feature.node.partOfReferenceImplementation
                    "
                  />
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import OZGLevelEmoji from "./../OZGLevelEmoji";
export default {
  name: "OZGServiceExplorer",
  components: { OZGLevelEmoji },
  data() {
    return {
      chosen: { id: "T1pHU2VydmljZU5vZGU6Nzk1" },
      preselected: "Führerschein",
      ozgService: null,
      ozgServiceSearch: null
    };
  },

  watch: {
    allOzgServices: function(newVal) {
      console.log(newVal);
      var service_search = [];
      for (var x in newVal.edges) {
        // Shows only the explicitly set index of "5", and ignores 0-4
        service_search.push({
          id: newVal.edges[x].node.id,
          value: newVal.edges[x].node.name
        });
      }
      this.ozgServiceSearch = service_search;
    }
  },
  apollo: {
    $client: "ozgClient",
    allOzgServices: {
      query: require("../../graphql/OZGServiceQuery.gql")
    },
    ozgService: {
      query: require("../../graphql/ozgService.gql"),
      // Static parameters
      variables() {
        // Use vue reactive properties here
        return {
          service_id: this.chosen.id
        };
      }
    }
  }
};
</script>

<style scoped lang="scss">
.typeahead {
  padding: 0;
}
.typeahead > .input-group > input {
  background-color: #fff;
  background-image: none;
  padding: 6px;
  font-size: 1.5rem;
  line-height: 2rem;
  text-align: left;
  font-family: "Open Sans Condensed", sans-serif;
  font-weight: 700;
  font-style: normal;
  border-radius: 1px;
  outline: 2px inset black;
  outline-offset: -2px;
  color: #111111;
  margin-bottom: -3px;
}
.black {
  border: #111111 solid 2px !important;
}
.typeahead > .input-group > input::-ms-expand {
  display: none;
}
.typeahead > .input-group > input:hover {
  border-color: #000;
}
.typeahead > .input-group > input:focus {
  border-color: #000;
  box-shadow: none;
  color: #222;
  outline: none;
}

.scrolling-list {
  max-height: 400px;
  overflow-y: scroll;
  padding-bottom: 30px;
}

.scrolling-list::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

.scrolling-list::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background-color: #111111;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.9);
}

.vbt-autcomplete-list {
  border-radius: 0px;

  .list-group-item:first-child {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
  .list-group-item:last-child {
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
}
.interactive-title {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
  font-style: italic;
}
.list-group-flush > .list-group-item {
  padding-left: 0;
}
</style>
